import React from 'react';
import Div from '../Div';
import Spacing from '../Spacing';
import PortfolioSlider from '../Slider/PortfolioSlider';
import SectionHeading from '../SectionHeading';
import { portfolioData } from '../../data/portfolioData';
import PageHeading from '../PageHeading';

const Project = () => {

    const portfolioStyling = {
        margin: "80px 0 50px",
    }

    return (
        <>
            {/* Start Page Heading Section */}
            <PageHeading
                title="Our Portfolio"
                bgSrc="images/about_hero_bg.jpeg"
                pageLinkText="Projects"
            />
            {/* End Page Heading Section */}

            <Div style={portfolioStyling} >
                <Div className="container" id="portfilo">
                    <SectionHeading
                        title="Portfolio to explore"
                        subtitle="Latest Projects"
                        variant="cs-style1 text-center"
                    />
                    <Spacing lg="90" md="45" />
                </Div>
                <PortfolioSlider data={portfolioData} />
            </Div>
        </>
    )
}

export default Project